var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-autocomplete',{attrs:{"size":"small","fetch-suggestions":_vm.querySearchAsync,"placeholder":"请输入关键词"},on:{"select":_vm.handleChange,"blur":_vm.handleBlur},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"label",attrs:{"title":item.value}},[_vm._v(_vm._s(item.value))])]}}]),model:{value:(_vm.ContactIds),callback:function ($$v) {_vm.ContactIds=$$v},expression:"ContactIds"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31031d62","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/ContactSelect.vue
// module id = 2243
// module chunks = 0